export default {"src":"/_next/static/media/qnt.7e7c8ad7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};